import React, { useState, useRef, useEffect } from "react";
import { Modal, Input, Spin, Form, Button, Icon } from "antd";
import { mailConversion, numberformatter } from "$ACTIONS/util";
import { pickNotNumberAllowDecimal } from "$ACTIONS/reg";
import { getE2BBValue } from "$ACTIONS/helper";
import { advpost } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import showPromotionErrorModal from "@/Promotion/UI";
import showMessage from "$ACTIONS/messageUtil";
import { manualPromotionEnrollment } from "$ACTIONS/promotionRequest";
const { TextArea } = Input;
const { Item } = Form;

// 已申請資料Modal
// daily deal、Manual promotion(Physical)
export function AppliedDataModal(props) {
    const { isVisible, onCancel, appliedItem } = props;
    const { bonusDailyDealsDetail } = appliedItem;

    return (
        <Modal
            width={400}
            title="ข้อมูลการรับรางวัล" //申请资料
            className="check-apply-data-container physical promotion-modal"
            visible={isVisible}
            onCancel={onCancel}
            footer={null}
        >
            {appliedItem && (
                <>
                    <h3>{appliedItem.bonusName}</h3>
                    <label>ที่อยู่ในการจัดส่ง</label>
                    {/* 邮寄地址 */}
                    <div className="info">
                        <p className="name">
                            {bonusDailyDealsDetail.firstName}
                        </p>
                        <p className="phone">{`+ 66 ${bonusDailyDealsDetail.contactNumber}`}</p>
                        {/* 联系电话 */}
                        <p className="address">{`${bonusDailyDealsDetail.address} ${bonusDailyDealsDetail.area} ${bonusDailyDealsDetail.city}
                        ${bonusDailyDealsDetail.province} ${bonusDailyDealsDetail.zipCode}`}</p>
                        {/* 地址 */}
                    </div>
                    <label>หมายเหตุ</label>
                    <div className="remark">
                        <p>{bonusDailyDealsDetail.remark}</p>
                        {/* 留言 */}
                    </div>
                </>
            )}
        </Modal>
    );
}
// 已申請資料Modal
// Manual promotion(Non Physical)
export function AppliedNonPhysicalDataModal(props) {
    const { isVisible, onCancel, appliedItem } = props;

    const popUpLiveChat = function () {
        global.PopUpLiveChat();
    };

    return (
        <Modal
            width={400}
            title="ข้อมูลการขอรับโบนัส" //申请资料
            className="check-apply-data-container non-physical promotion-modal"
            visible={isVisible}
            onCancel={onCancel}
            footer={null}
        >
            {appliedItem && (
                <>
                    <h3>{appliedItem.promotionTitle}</h3>
                    <div className="user-info">
                        <Input
                            addonBefore="ยูสเซอร์เนม" //用户名
                            defaultValue={localStorage.getItem("UserName")}
                            disabled
                        />
                        <div>
                            <Input
                                addonBefore="อีเมล" //电子邮箱
                                defaultValue={mailConversion(
                                    appliedItem.emailAddress
                                )}
                                disabled
                            />
                            <p>
                                กรุณาติดต่อ
                                <span onClick={popUpLiveChat}>
                                    ฝ่ายบริการลูกค้า{" "}
                                </span>
                                หากท่านต้องการแก้ไขข้อมูลอีเมล
                                {/* 如果您想更新电子邮箱，请联系我们的在线客服 */}
                            </p>
                        </div>
                        <div>
                            <Input
                                addonBefore="เบอร์โทร" //联系电话
                                defaultValue={`******${appliedItem.contactNo.slice(
                                    6
                                )}`}
                                disabled
                            />
                            <p>
                                กรุณาติดต่อ
                                <span onClick={popUpLiveChat}>
                                    ฝ่ายบริการลูกค้า{" "}
                                </span>
                                หากท่านต้องการแก้ไขข้อมูลอีเมล
                                {/* 如果您想更新联系电话，请联系我们的在线客服 */}
                            </p>
                        </div>
                        <div className="ant-input-group-wrapper">
                            <label>ฝากข้อความเพิ่ม</label>
                            {/* 留言 */}
                            <TextArea value={appliedItem.remarks} disabled />
                        </div>
                    </div>
                </>
            )}
        </Modal>
    );
}
export function ManualModal({
    promotionInfo,
    memberInfo,
    isVisible,
    closeModal,
    onSuccess,
}) {
    const [remarks, setRemarks] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const maxLength = 100;

    const handleTextareaChange = (e) => {
        setRemarks(e.target.value);
    };

    /**
     * @description: Manual Promotion 申請 Handler
     * @return {*}
     */
    const submitApplyManual = async () => {
        setIsSubmitting(true);

        try {
            const { campaignData } = promotionInfo || {};
            const { id: entryPeriodId } = campaignData?.entryPeriod || {};
            const params = {
                entryPeriodId: entryPeriodId,
                siteId: 37,
                formData: {
                    formType: 1,
                    remark: remarks,
                    address: "",    
                    prize: "",
                    shirtSize: "",
                },
            };

            const res = await manualPromotionEnrollment(2, params);
            if (res?.isSuccess && res?.result?.isSuccess) {
                showMessage("success", "สมัครโปรโมชั่นสำเร็จ", 80); //优惠申请成功
                closeModal();
                onSuccess();
            } else {
                const errorCode = res?.result?.errorCode;
                const apiMessage = res?.result?.message;
                showPromotionErrorModal(errorCode, apiMessage);
            }
        } catch (error) {
            console.error("submitApplyManual error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            className="custom-modal-white-bg manual-apply-modal"
            title={"การขอรับโปรโมชั่น"} //申请资料
            centered={true}
            destroyOnClose={true}
            footer={false}
            visible={isVisible}
            width={400}
            onCancel={() => {
                closeModal();
                setRemarks("");
            }}
        >
            <div>
                <Spin
                    spinning={isSubmitting}
                    size="large"
                    tip="กำลังดำเนินการ กรุณารอสักครู่..." //正在为您申请，请稍后...
                >
                    <Form layout="vertical" className="Formbox">
                        <h3>{promotionInfo?.promoTitle}</h3>
                        <Item label="ยูสเซอร์เนม" colon={false}>
                            {/* 用户名 */}
                            <Input
                                defaultValue={memberInfo.userName}
                                disabled
                                size="large"
                            />
                        </Item>
                        <Item
                            label="อีเมล"
                            colon={false}
                            extra={
                                <p>
                                    กรุณาติดต่อ
                                    <span
                                        onClick={() => {
                                            Pushgtagdata(
                                                "Promotion_Detail",
                                                "Contact CS",
                                                "Promotion_Detail_C_CS"
                                            );
                                            global.PopUpLiveChat();
                                        }}
                                    >
                                        ฝ่ายบริการลูกค้า
                                    </span>
                                    หากท่านต้องการแก้ไขข้อมูลอีเมล
                                    {/* 如果您想更新电子邮箱，请联系我们的在线客服 */}
                                </p>
                            }
                        >
                            {/* 电子邮箱 */}
                            <Input
                                defaultValue={memberInfo?.isVerifiedEmail?.[0] ?? ""}
                                disabled
                                size="large"
                            />
                        </Item>
                        <Item
                            label="เบอร์ติดต่อ"
                            colon={false}
                            extra={
                                <p>
                                    กรุณาติดต่อ
                                    <span
                                        onClick={() => {
                                            Pushgtagdata(
                                                "Promotion_Detail",
                                                "Contact CS",
                                                "Promotion_Detail_C_CS"
                                            );
                                            global.PopUpLiveChat();
                                        }}
                                    >
                                        ฝ่ายบริการลูกค้า
                                    </span>
                                    หากท่านต้องการแก้ไขข้อมูลอีเมล
                                    {/* 如果您想更新联系电话，请联系我们的在线客服 */}
                                </p>
                            }
                        >
                            {/* 联系电话 */}
                            <Input
                                defaultValue={memberInfo?.isVerifiedPhone?.[0] ?? ""}
                                disabled
                                size="large"
                            />
                        </Item>
                        <Item
                            label="ข้อความ"
                            colon={false}
                            extra={
                                <div className="remark">{`${remarks?.length}/${maxLength}`}</div>
                            }
                            className="remarks-item"
                        >
                            {/* 留言 */}
                            <TextArea
                                value={remarks}
                                size="large"
                                onChange={(e) => handleTextareaChange(e)}
                                maxLength={maxLength}
                                placeholder="กรุณากรอกรายละเอียดสำหรับฝากข้อความเพิ่ม"
                            />
                        </Item>
                        <Button
                            type="primary"
                            size="large"
                            block
                            disabled={!remarks}
                            className="button"
                            onClick={() => {
                                Pushgtagdata(
                                    "Promotion",
                                    "Submit Promotion Form",
                                    "Promotion_S_Application",
                                    false,
                                    [
                                        {
                                            customVariableKey: `Promotion_S_Application_PromoName_PrmoID`,
                                            customVariableValue: `${promotionInfo?.promoTitle}_${promotionInfo?.promoId}`,
                                        },
                                    ]
                                );
                                submitApplyManual();
                            }}
                        >
                            {/* 提交 */}
                            ส่งข้อมูล
                        </Button>
                    </Form>
                </Spin>
            </div>
        </Modal>
    );
}

export function BonusModal({
    promotionInfo,
    balanceInfo,
    isVisible,
    closeModal,
    onSuccess,
}) {
    const [amount, setAmount] = useState(""); // 儲存金額
    const [error, setError] = useState(""); // 儲存錯誤訊息
    const [bonus, setBonus] = useState(0); //紅利金額
    const [turnover, setTurnover] = useState(0); //所需流水金額
    const [isFetching, setIsFetching] = useState(false); // 處理 bonus API 的 loading 狀態
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isBonusValid, setIsBonusValid] = useState(false); // 確保 Bonus 正確才允許提交
    const debounceTimeout = useRef(null); // 儲存 debounce 的計時器

    // 調用 API 獲取 bonus 和 turnover 數字
    const fetchBonusData = async (value) => {
        setIsFetching(true); // 啟用 loading
        setIsBonusValid(false); // 在 API 回應前先標記 bonus 無效

        try {
            const params = {
                bonusMode: "Deposit",
                bonusId: promotionInfo?.bonusData?.id,
                bonusRuleGroupId: promotionInfo?.bonusData?.groupID,
                amount: value,
                memberBalance: balanceInfo?.MAIN?.balance || 0,
                wallet: promotionInfo?.bonusData?.account,
            };
            const res = await advpost(ApiPort.POSTCalculateBonus, params);

            if (res?.isSuccess && res?.result) {
                const { bonusGiven, turnoverRequire, errorMessage } = res.result;

                if (errorMessage) {
                    setError(errorMessage);
                    setBonus(0);
                    setTurnover(0);
                    setIsBonusValid(false); // API 回應成功，bonus 無效
                } else {
                    setError("");
                    setBonus(bonusGiven);
                    setTurnover(turnoverRequire);
                    setIsBonusValid(true); // API 回應成功，bonus 有效
                }
            } else {
                showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
                setBonus(0);
                setTurnover(0);
                setIsBonusValid(false);
            }
        } catch (apiError) {
            console.error("API Error:", apiError);
            setBonus(0);
            setTurnover(0);
            setIsBonusValid(false);
        } finally {
            setIsFetching(false); // 關閉 loading
        }
    };

    // 處理輸入金額
    const handleChange = (e) => {
        if (isFetching) return; // 如果正在獲取數據，則不允許輸入
    
        const value = e.target.value.replace(pickNotNumberAllowDecimal, ""); // 清除非法字符
        setAmount(value);
        setError("");
    };

    // 提交表單
    const handleSubmit = async () => {
        if (!amount || isFetching || !!error || !isBonusValid) return;

        setIsSubmitting(true);

        try {
            const params = {
                blackBox: getE2BBValue(),
                e2BlackBoxValue: getE2BBValue(),
                bonusId: promotionInfo?.bonusData?.id,
                bonusGroupId: promotionInfo?.bonusData?.groupID,
                amount: amount,
                targetWallet: promotionInfo?.bonusData?.account,
            };
            const res = await advpost(ApiPort.POSTBonusApplications, params);
            if (res?.isSuccess) {
                showMessage("success", "สมัครโปรโมชั่นสำเร็จ", 80); //提交成功
                closeModal();
                onSuccess();
            } else {
                const errorCode = res?.result?.errorCode;
                const apiMessage = res?.result?.message;
                showPromotionErrorModal(errorCode, apiMessage);
            }
        } catch (error) {
            console.error("Submit Error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current); // 清除舊的計時器
        }
    
        if (!amount) {
            setBonus(0);
            setTurnover(0);
            setIsBonusValid(false);
            return;
        }
    
        // 設置新的 debounce 計時器
        debounceTimeout.current = setTimeout(() => {
            fetchBonusData(amount); // 調用 API
        }, 500); // 500ms 防抖
    
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current); // 清理舊的 debounce 計時器
            }
        };
    }, [amount]); // 監聽 `amount` 變更
    

    return (
        <Modal
            className="custom-modal-white-bg bonus-applied-modal"
            title={"การขอรับโปรโมชั่น"} //优惠活动申请
            centered={true}
            destroyOnClose={true}
            footer={false}
            visible={isVisible}
            width={400}
            onCancel={() => {
                closeModal();
            }}
        >
            <div>
                <Spin
                    spinning={isFetching || isSubmitting}
                    size="large"
                    // 加载中，请稍后... / 正在为您申请，请稍后...
                    tip={
                        isFetching
                            ? "กำลังโหลด กรุณารอสักครู่..."
                            : "กำลังดำเนินการ กรุณารอสักครู่..."
                    }
                >
                    <Form layout="vertical">
                        <p className="bonus-applied-title">
                            {promotionInfo?.promoTitle}
                        </p>
                        <Form.Item
                            label="ยอดเงิน"
                            validateStatus={error ? "error" : ""}
                            help={error}
                            colon={false}
                        >
                            {/* 申请金额 */}
                            <Input
                                placeholder="กรุณากรอกยอดเงิน"
                                value={amount}
                                onChange={handleChange}
                                size="large"
                                disabled={isFetching} // 輸入框在 fetching 時禁用
                            />
                        </Form.Item>

                        <Form.Item label="โบนัสที่มีอยู่" colon={false}>
                            {/* 可得彩金 */}
                            <Input
                                value={numberformatter(
                                    bonus,
                                    2,
                                    "removeWhenDecimalAllZero"
                                )}
                                disabled
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item label="ยอดหมุนเวียนที่ต้องการ" colon={false}>
                            {/* 所需流水 */}
                            <Input
                                value={numberformatter(
                                    turnover,
                                    2,
                                    "removeWhenDecimalAllZero"
                                )}
                                disabled
                                size="large"
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            disabled={!amount || !!error || isFetching || !isBonusValid} // 金額為空、有錯誤、正在加載、API 失敗時，禁用按鈕
                            onClick={handleSubmit}
                            size="large"
                            block
                        >
                            {/* 提交 */}
                            ส่งข้อมูล
                        </Button>
                    </Form>
                </Spin>
            </div>
        </Modal>
    );
}
